module.exports = __webpack_public_path__ + "img/mac.9447627b.svg";